define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');

    var PagingViewController = ViewController.extend({
        ControllerName: "PagingViewController",

        LPViewMap: {
            pagingComponentsWrapper: '.lpview_paging_components_wrapper',
            pagingText: '.lpview_paging_text',
            displayedPageNumber: '.lpview_displayed_page_number',
            maxPageNumber: '.lpview_max_page_number',
            prevButton: '.lpview_prev_button',
            nextButton: '.lpview_next_button'
            //startButton : '.lpview_start_button',
            //endButton : '.lpview_end_button'
        },

        LPClassesMap: {
            disabled: 'disabled'
        },
        permutation: {
            jump2Page: "A",
            start2End: "B"
        },

        initialize: function (constructorData) {
            this.pageSize = constructorData.pageSize || 50;
            this.tableItemsCountModelPath = constructorData.tableItemsCountModelPath;
            this.tableItemsStateModelPath = constructorData.tableItemsStateModelPath;
            this.tableLastSentQueryModelPath = constructorData.tableLastSentQueryModelPath;
            this.textsPrefix = constructorData.textsPrefix;
            this.updateQueryCallback = constructorData.updateQueryCallback;
            this.tableName = constructorData.tableName;
            this.context = constructorData.context || this;
            //  PreFiltering setting
            this.permutationSelect = constructorData.permutation || this.permutation.jump2Page;
            // Hide the text next to the buttons
            this.hidePagingText = constructorData.hidePagingText || false;
            //this.tableItemsCurrIndexModelPath = constructorData.tableItemsCurrIndexModelPath;
            this.tableItemsNextIndexModelPath = constructorData.tableItemsNextIndexModelPath;
            this.tableItemsPrevIndexModelPath = constructorData.tableItemsPrevIndexModelPath;
            this.tableItemsCurrIndexModelPath = constructorData.tableItemsCurrIndexModelPath;

            this.buttonsCallback = {};
            this.buttonsCallback[this.LPViewMap.prevButton] = this.getPreviousPage;
            this.buttonsCallback[this.LPViewMap.nextButton] = this.getNextPage;
            //this.buttonsCallback[this.LPViewMap.startButton] = this.get2StartPage;
            //this.buttonsCallback[this.LPViewMap.endButton] = this.get2EndPage;


            this.count = 0;
            var startPage = 1;

            if (!constructorData.templateFile) {
                if (this.permutationSelect === this.permutation.jump2Page) {
                    this.createView({templateFile: "LP_paging.html"});

                    this.currentPageInputVC = new NumericInputViewController({
                        defaultInputValue: this.modelController.getSessionData({
                            name: this.tableName,
                            key: "displayedPage"
                        }) || startPage,
                        minimumInputValue: startPage,
                        valueChangedCallback: this.getPage,
                        context: this,
                        revertOnBlur: true
                    });

                    this.addViewController({
                        viewController: this.currentPageInputVC,
                        target: this.LPViewMap.displayedPageNumber
                    });
                } else {
                    this.createView({templateFile: "LP_paging_start2end.html"});
                }
            }
        },

        events: function () {
            if (this.tableItemsCountModelPath && this.tableItemsStateModelPath) {
                if (this.permutationSelect === this.permutation.jump2Page) {
                    this.bindModel({modelPath: this.tableItemsCountModelPath, callback: this.handleCountChanged});
                    this.bindModel({modelPath: this.tableItemsStateModelPath, callback: this.handleTableStateChanged});
                    this.bindViewEvent({
                        selector: this.LPViewMap.displayedPageNumber,
                        DOMEvent: 'keyup',
                        callback: this.handleKeyUp
                    });
                    this.bindViewEvent({
                        selector: this.LPViewMap.displayedPageNumber,
                        DOMEvent: 'blur',
                        callback: this.updateCurrentPageNumber
                    });
                } else {
                    this.bindModel({
                        modelPath: this.tableItemsCountModelPath,
                        callback: this.handleCountChangedPreFiltering
                    });
                    //this.bindButtonClick(this.LPViewMap.startButton, true);
                    //this.bindButtonClick(this.LPViewMap.endButton, true);
                }
                this.bindButtonClick(this.LPViewMap.prevButton, true);
                this.bindButtonClick(this.LPViewMap.nextButton, true);
            }
        },

        render: function () {
            this.lpHide();
        }
    });

    /**
     * This function set bind or unbind to paging buttons include css class
     * @param buttonView    - The button view (from this.LPViewMap)
     * @param state         - Bind (true) or unbind (false), Default: true
     * @param context       - context, Default this
     */
    PagingViewController.prototype.bindButtonClick = function (buttonView, state, context) {
        if (!context) {
            context = this;
        }
        if (typeof state == "undefined") {
            state = true;
        }
        if (state) {
            context.unbindViewEvent({selector: buttonView, DOMEvent: 'click', callback: this.buttonsCallback[buttonView]});
            context.bindViewEvent({selector: buttonView, DOMEvent: 'click', callback: this.buttonsCallback[buttonView]});
            context.removeClass(buttonView, context.LPClassesMap.disabled);
        } else {
            context.unbindViewEvent({selector: buttonView, DOMEvent: 'click', callback: this.buttonsCallback[buttonView]});
            context.addClass(buttonView, context.LPClassesMap.disabled);
        }
    };

    PagingViewController.prototype.getPreviousPage = function (clickedElement) {
        if (this.hasSingleClass(clickedElement.currentTarget, 'disabled')) {
            return;
        }
        if (this.permutationSelect === this.permutation.jump2Page) {
            if (this.getCurrentPage() === this.getStartPage() || this.getCurrentPage() <= 1) {
                return;
            }
            this.setCurrentPage(this.getCurrentPage() - 1);
            this.getPage();
        } else {
            var prevIndex = this.getModelParam(this.tableItemsPrevIndexModelPath);
            if (typeof prevIndex == "number") {
                this.updateQueryCallback.call(this.context, {skip: prevIndex, limit: this.pageSize});
            }
        }
    };

    PagingViewController.prototype.getNextPage = function (clickedElement) {
        if (this.hasSingleClass(clickedElement.currentTarget, 'disabled')) {
            return;
        }
        if (this.permutationSelect === this.permutation.jump2Page) {
            if (this.getCurrentPage() === this.getMaxPage()) {
                return;
            }
            this.setCurrentPage(this.getCurrentPage() + 1);
            this.getPage();
        } else {
            var nextIndex = this.getModelParam(this.tableItemsNextIndexModelPath);
            if (typeof nextIndex == "number") {
                this.updateQueryCallback.call(this.context, {skip: nextIndex, limit: this.pageSize});
            }
        }
    };

    /*PagingViewController.prototype.get2StartPage = function (clickedElement) {
     if (this.hasSingleClass(clickedElement.currentTarget, 'disabled')) {
     return;
     }
     var firstIndex = this.getModelParam(this.tableItemsFirstIndexModelPath);
     if (typeof firstIndex == "number") {
     this.updateQueryCallback.call(this.context, {skip: firstIndex, limit: this.pageSize});
     }
     };

     PagingViewController.prototype.get2EndPage = function (clickedElement) {
     if (this.hasSingleClass(clickedElement.currentTarget, 'disabled')) {
     return;
     }
     var lastIndex = this.getModelParam(this.tableItemsLastIndexModelPath);
     if (typeof lastIndex == "number") {
     this.updateQueryCallback.call(this.context, {skip: lastIndex, limit: this.pageSize});
     }
     };*/

    PagingViewController.prototype.updatePagingComponents = function () {
        var currentInputPage = this.getCurrentPage();
        if(currentInputPage !== this.currentPage){
            this.setCurrentPage(this.currentPage);
        }
        this.updatePagingButtons();
    };

    PagingViewController.prototype.updatePagingButtons = function () {
        updatePagingButton(this, this.LPViewMap.nextButton);
        updatePagingButton(this, this.LPViewMap.prevButton);
        var displayedPageNumberElement = this.getFirstElement(this.LPViewMap.displayedPageNumber);
        if (displayedPageNumberElement) {
            displayedPageNumberElement.removeAttribute("disabled");
        }

        function updatePagingButton(context, buttonView) {
            var isButtonDisabled, comparator;

            if (buttonView === context.LPViewMap.nextButton) {
                comparator = context.getCurrentPage() < context.getMaxPage();
            } else { //prev button
                comparator = context.getCurrentPage() !== context.getStartPage();
            }

            if (comparator) {
                isButtonDisabled = false;
                context.bindButtonClick(buttonView, true, context);
            } else {
                isButtonDisabled = true;
                context.bindButtonClick(buttonView, false, context);

            }
            context.getFirstElement(buttonView).disabled = isButtonDisabled;
        }
    };

    PagingViewController.prototype.handleCountChanged = function (data) {
        if (typeof data.newValue !== "undefined") {
            this.count = data.newValue;
            if (typeof this.count === 'string') {
                this.count = parseInt(this.count, 10);
            }
            var maxPageNumber = Math.floor(this.count / this.pageSize);
            var remainder = this.count % this.pageSize;
            if (remainder) {
                maxPageNumber++;
            }
            this.setMaxPage(maxPageNumber);

            var itemsCountText = '';
            if (this.getMaxPage() > this.getStartPage()) {
                var maxPageNumberElement = this.getFirstElement(this.LPViewMap.maxPageNumber);
                if (maxPageNumberElement) {
                    maxPageNumberElement.innerHTML = this.getMaxPage();
                }
                this.lpShow(this.LPViewMap.pagingComponentsWrapper);
                // If paging is active - we're showing the number of visitors per page
                var startIdx = (this.pageSize * (this.getCurrentPage() - 1)) + 1;
                // But if we're on the last page - we're only showing the remainder (if it doesn't divide evenly)

                // Setting the end index to add the number of visitors on page,if it is the last page only adding the remainder
                var endIdx = startIdx + this.pageSize - 1;
                if (this.getCurrentPage() === this.getMaxPage() && remainder) {
                    endIdx = startIdx + remainder - 1;
                }

                itemsCountText = this.translateObj(this.textsPrefix + '_PartialItems', [startIdx, endIdx, this.count]);
            } else {
                if (this.count > 0) {
                    // If there is no paging - we only show the number of visitors text if there are visitors
                    if (this.count > 1) {
                        // If there are several visitors - using the plural text
                        itemsCountText = this.translateObj(this.textsPrefix + '_TotalItemsMulti', [this.count]);
                    } else {
                        // If there's only one visitor - using the singular text
                        itemsCountText = this.translate(this.textsPrefix + '_TotalItemsSingle');
                    }
                }
                this.lpHide(this.LPViewMap.pagingComponentsWrapper);
            }
            var pagingTextElement = this.getFirstElement(this.LPViewMap.pagingText);
            if (pagingTextElement && !this.hidePagingText) {
                pagingTextElement.innerHTML = itemsCountText;
            }
            this.updatePagingComponents();
        }
    };

    PagingViewController.prototype.updatePagingComponentsPreFiltering = function () {
        var last = -99999999;
        var currIndex = this.getModelParam(this.tableItemsCurrIndexModelPath);
        var prevIndex = this.getModelParam(this.tableItemsPrevIndexModelPath);
        var nextIndex = this.getModelParam(this.tableItemsNextIndexModelPath);
        // Check the prevIndex and set the prev and start button state
        if (typeof prevIndex === 'string') {
            prevIndex = parseInt(prevIndex, 10);
        }
        if (currIndex === 0) {// if currIndex = 0 this is the first page
            this.bindButtonClick(this.LPViewMap.prevButton, false);
            //this.bindButtonClick(this.LPViewMap.startButton, false);
        } else {
            this.bindButtonClick(this.LPViewMap.prevButton, true);
            //this.bindButtonClick(this.LPViewMap.startButton, true);
        }
        // Check the nextIndex and set the next and end button state
        if (typeof nextIndex === 'string') {
            nextIndex = parseInt(prevIndex, 10);
        }
        if (nextIndex == last) { // if nextIndex = lastIndex, this is the last page
            this.bindButtonClick(this.LPViewMap.nextButton, false);
            //this.bindButtonClick(this.LPViewMap.endButton, false);
        } else {
            this.bindButtonClick(this.LPViewMap.nextButton, true);
            //this.bindButtonClick(this.LPViewMap.endButton, true);
        }

        // If this is the only page to show, hide the buttons
        if (currIndex === 0 && nextIndex == last) {
            this.lpHide(this.LPViewMap.pagingComponentsWrapper);
        } else {
            this.lpShow(this.LPViewMap.pagingComponentsWrapper);
        }

        // Set the text next to the buttons
        if (!this.hidePagingText) {
            var itemsCountText = '';
            if (this.count > 0) {
                // If there is no paging - we only show the number of visitors text if there are visitors
                if (this.count > 1) {
                    // If there are several visitors - using the plural text
                    itemsCountText = this.translateObj(this.textsPrefix + '_PreFiltering_TotalItemsMulti', [this.count]);
                } else {
                    // If there's only one visitor - using the singular text
                    itemsCountText = this.translate(this.textsPrefix + '_PreFiltering_TotalItemsSingle');
                }
            }
            var pagingTextElement = this.getFirstElement(this.LPViewMap.pagingText);
            if (pagingTextElement) {
                pagingTextElement.innerHTML = itemsCountText;
            }
        }
    };

    PagingViewController.prototype.handleCountChangedPreFiltering = function (data) {
        if (typeof data.newValue !== "undefined") {
            this.count = data.newValue;
            if (typeof this.count === 'string') {
                this.count = parseInt(this.count, 10);
            }
            this.updatePagingComponentsPreFiltering();
        }
    };

    PagingViewController.prototype.disablePagingComponents = function () {
        var pagingTextElement = this.getFirstElement(this.LPViewMap.pagingText);
        if (pagingTextElement) {
            pagingTextElement.innerHTML = "";
        }
        this.bindButtonClick(this.LPViewMap.nextButton, false);
        this.bindButtonClick(this.LPViewMap.prevButton, false);
        var displayedPageNumberElement = this.getFirstElement(this.LPViewMap.displayedPageNumber);
        if (displayedPageNumberElement) {
            displayedPageNumberElement.disabled = "disabled";
        }
    };

    PagingViewController.prototype.handleTableStateChanged = function (data) {
        if (data && data.newValue) {
            switch (data.newValue.status) {
                case "fetching":
                    this.disablePagingComponents();
                    break;
                case "fetched":
                    this.handleContentLoaded(data);
                    break;
            }
        }
    };

    PagingViewController.prototype.handleContentLoaded = function (data) {
        var lastQuery = this.getModelParam(this.tableLastSentQueryModelPath);
        if (lastQuery && typeof(lastQuery.limit) !== "undefined" && typeof(lastQuery.skip) !== "undefined") {
            this.pageSize = lastQuery.limit;
            this.currentPage = (lastQuery.skip / this.pageSize) + 1;
            this.updatePagingComponents();
        }

        if (data.newValue && typeof data.newValue.itemsCount !== "undefined") {
            if (data.newValue.itemsCount === 0) {
                if (this.getMaxPage() >= this.getStartPage() && this.getCurrentPage() > this.getMaxPage()) {// we requested a page that no longer has items, but the total items count is larger than 0
                    if (this.pageFallback === true) { //the second auto re-direct - go to the first Visitors List page
                        this.setCurrentPage(this.getStartPage());
                        delete this.pageFallback;
                    } else {
                        this.pageFallback = true; //the first auto re-direct - go to the last Visitors List page available
                        this.setCurrentPage(this.getMaxPage());
                    }
                    this.getPage();
                }
            }
        }
    };

    PagingViewController.prototype.getPage = function (pageNumber) {
        if (pageNumber) {
            this.setCurrentPage(pageNumber);
        }
        var current = this.getCurrentPage() || 1; // if this is not jump2Page we will go to the first page
        this.updateQueryCallback.call(this.context, {
            skip: this.pageSize * (current - 1),
            limit: this.pageSize
        });
    };

    PagingViewController.prototype.getCurrentPage = function () {
        if (!this.currentPageInputVC) {
            return;
        }
        return this.currentPageInputVC.currentInputValue;
    };

    PagingViewController.prototype.setCurrentPage = function (value) {
        if (!this.currentPageInputVC) {
            return;
        }
        this.currentPageInputVC.setCurrentInputValue(value);
    };

    PagingViewController.prototype.getStartPage = function () {
        if (!this.currentPageInputVC) {
            return;
        }
        return this.currentPageInputVC.minimumInputValue;
    };

    PagingViewController.prototype.setStartPage = function (value) {
        if (!this.currentPageInputVC) {
            return;
        }
        this.currentPageInputVC.setMinimumInputValue(value);
    };

    PagingViewController.prototype.getMaxPage = function () {
        if (!this.currentPageInputVC) {
            return;
        }
        return this.currentPageInputVC.maximumInputValue;
    };

    PagingViewController.prototype.setMaxPage = function (value) {
        if (!this.currentPageInputVC) {
            return;
        }
        this.currentPageInputVC.setMaximumInputValue(value);
    };

    return PagingViewController;

});
